import { getYoutubeVideoCover } from "@/utils/youtube";
import BlogContent from "../BlogContent";
import { BLOG_TAGS } from "../BlogTags";

const PODCAST_4: BlogContent = {
  id: 16,
  label: "Kodėl vien papildų neužtenka?",
  description:
    "Sužinokite, kaip personalizuoti maisto papildai gali tapti tikslu keliu į realius rezultatus. Kaip pasiekti greičiausią ir didžiausią efektą, remiantis mokslo duomenimis, o ne rinkodaros pažadais. Taip pat, atskleidžiame, kodėl daugelis papildų neveikia ir kaip išsirinkti tai, kas iš tiesų veikia tavo organizmui.",
  descriptionInner:
    "Sužinokite, kaip personalizuoti maisto papildai gali tapti tikslu keliu į realius rezultatus. Kaip pasiekti greičiausią ir didžiausią efektą, remiantis mokslo duomenimis, o ne rinkodaros pažadais. Taip pat, atskleidžiame, kodėl daugelis papildų neveikia ir kaip išsirinkti tai, kas iš tiesų veikia tavo organizmui.",
  img_src: getYoutubeVideoCover("7xMmP0JWU2c"),
  alt: "Podcast ep.4",
  tags: [BLOG_TAGS.PODCASTS.label, BLOG_TAGS.SUPPLEMENTS.label],
  innerData: [
    {
      id: 1,
      description: [
        "Papildų rinkoje itin daug chaoso: reklamos, prieštaringa informacija, dešimtys kapsulių ir neaiškios dozuotės. Dažnai žmonės tikisi greito efekto, bet tikrasis klausimas yra ne „kokio papildo dar trūksta?“, o kas vyksta mano organizme iš tikrųjų.",
        <span>
          👉 Norite tik Jums skirto maisto papildų plano? Užpildykite klausimyną
          ir gaukite farmacininko Jokūbo rekomendacijas:{" "}
          <a
            href="https://telomera.typeform.com/eternalife?typeform-source=www.telomera.lt"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
          >
            https://telomera.typeform.com/eternalife
          </a>
        </span>,
      ],
    },
  ],
  podcasts: {
    youtube: "7xMmP0JWU2c",
    spotify: "0NmgNsAr3UF6pr5POBdHK6?si=cafc882cfab84199",
    apple: "1000732979086",
  },
};

export default PODCAST_4;
